"use client";
import Link from "next/link";
import HeadingSize from "../ui/HeadingSize";
import Image from "next/image";

const ResponsivePicture = ({
  baseSrc,
  alt,
  className,
  layout = "fill",
}: {
  baseSrc: string;
  alt: string;
  className?: string;
  layout?: "fill" | "intrinsic";
}) => (
  <picture>
    <source srcSet={`${baseSrc}.webp`} type="image/webp" />
    <source srcSet={`${baseSrc}.png`} type="image/png" />
    <Image
      src={`${baseSrc}.webp`}
      alt={alt}
      fill={layout === "fill"}
      width={layout === "intrinsic" ? 800 : undefined}
      height={layout === "intrinsic" ? 600 : undefined}
      loading="lazy"
      placeholder="blur"
      blurDataURL="/images/placeholder.png"
      className={className}
    />
  </picture>
);

const GlobalMapSection = () => {
  return (
    <section className="bg-white w-full" aria-labelledby="global-map-heading">
      <div className="py-2">
        <div className="flex flex-col md:flex-row items-center gap-8 mb-8 lg:mb-4">
          <div className="w-full md:w-1/2 md:-ml-[5%]">
            {/* Mobile Map */}
            <div className="md:hidden relative aspect-[16/9] w-full px-4">
              <ResponsivePicture
                baseSrc="/images/global-map"
                alt="Ryze Global Presence Map (Mobile)"
                className="object-contain border-0"
              />
            </div>

            {/* Desktop Map */}
            <div className="hidden md:block relative aspect-[4/3] w-[110%]">
              <ResponsivePicture
                baseSrc="/images/home/worldmap"
                alt="Ryze Global Presence Map (Desktop)"
                className="object-contain"
              />
            </div>
          </div>

          {/* Text Block */}
          <div className="w-full md:w-1/2 px-4 md:px-8 lg:px-24 2xl:px-32 text-center md:text-left mt-8 md:mt-0">
            <div
              id="global-map-heading"
              className="mb-6 md:mb-6 lg:mb-8"
              aria-level={2}
            >
              <HeadingSize text="Ryze around the world" />
            </div>
            <p className="text-[#000000] text-base sm:text-2xl md:text-[22px] lg:text-[28px] xl:text-[28px] 2xl:text-[32px] w-full md:max-w-2xl mx-auto md:mx-0 md:leading-normal 2xl:leading-normal">
              Our presence has reached difference corners of the world, and is
              continually expanding, making more people take that first step
              towards freedom!
            </p>
          </div>
        </div>

        {/* CTA Button */}
        <div className="text-center mb-8">
          <Link
            href="/pages/science"
            aria-label="Learn more about the science behind Ryze"
            data-test-id="learn-more-cta"
            className="bg-[#FF0000] text-white px-20 py-2 text-[22px] font-normal rounded-tl-[30px] rounded-br-[30px] min-w-[180px] hover:bg-[#8f000a] transition-colors inline-block text-center"
          >
            Learn more
          </Link>
        </div>
      </div>
    </section>
  );
};

export default GlobalMapSection;
